<template>
  <div style="background-color: #f0f0f0">
    <div class="text-left p-4" style="background-color: #f0f0f0">
      <img class="w-50" src="../assets/logo2.png" />
    </div>
    <div class="header-second">
      <div class="header-second-container">
        <div class="nav-main">
          <nav role="navigation" class="site-navigation main-navigation">
            <ul class="dropdown">
              <li
                v-for="item in menu"
                :key="item.name"
                class="menu-item"
                :class="{ current: item.name === currentMenu }"
              >
                <a hidefocus="true" style="outline: none" @click="clickMenu(item.name)">
                  <span>{{ item.title }}</span>
                </a>
                <ul v-if="item.subs" class="submenu-1">
                  <li v-for="sub in item.subs" :key="sub.name" class="menu-item">
                    <a
                      hidefocus="true"
                      style="outline: none"
                      @click="clickSub(item.name, sub.name)"
                    >
                      <span>{{ sub.title }}</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <div class="site-main">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>

    <!-- Footer -->
    <div>
      <footer class="page-footer font-small footer-info-container pt-4 justify-content-md-center">
        <div class="container-fluid text-center text-md-left">
          <div class="row">
            <div class="col-md-6 mt-md-0 mt-3">
              <h5 class="text-uppercase">云步互娱</h5>
              <p>
                深圳云步互娱网络科技有限公司是一家以智能手机游戏研发、运营及发行为核心业务的互动娱乐企业。公司致力于精品手机游戏的研发和发行，希望为全球用户带来全新的游戏体验。
              </p>
            </div>
            <hr class="clearfix w-100 d-md-none pb-3" />
            <div class="col-md-4 mb-md-0 mb-3">
              <h5 class="text-uppercase">动态</h5>
              <mdb-container>
                <mdb-row>
                  <mdb-col>
                    <div v-for="item in newsItem" :key="item.nameTag" class="news">
                      <mdb-row>
                        <mdb-col col="3">
                          <mdb-view hover rounded class="z-depth-1-half mb-4">
                            <img class="img-fluid" :src="item.playImg" />
                          </mdb-view>
                        </mdb-col>
                        <mdb-col col="9">
                          <p class="font-weight-bold third">
                            {{ item.nameShow }}
                          </p>
                          <div class="d-flex justify-content-between">
                            <mdb-col class="text-truncate pl-0 mb-3">
                              <a class="news-content-p" @click="gotoDetail(item.nameTag)">{{
                                item.desc
                              }}</a>
                            </mdb-col>
                          </div>
                        </mdb-col>
                      </mdb-row>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-container>
            </div>
          </div>
        </div>

        <div class="copyright">
          <p>
            © 2016-2023 云步互娱 版权所有
            <a href="https://beian.miit.gov.cn/" class hidefocus="true" style="outline: none">
              粤B2-20160649</a
            >
            |
            <a href="https://beian.miit.gov.cn/" class hidefocus="true" style="outline: none">
              粤ICP备16045558号</a
            >
            |
            <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502002368"
              hidefocus="true"
              style="outline: none"
            >
              <img src="../assets/gongan.png" style="width: 16px; height: 16px" />
              <font style="height: 20px; line-height: 20px; margin: 0px 0px 0px 0px; color: #939393"
                >粤公网安备44030502002368号
              </font>
            </a>
            <!-- <a
              style="float: right; outline: none"
              target="_blank"
              href="http://www.yunbu.me/en/"
              hidefocus="true"
            >
              <font>英文</font>
            </a> -->
          </p>
          <p>
            <a href="privacy_policy.html" class hidefocus="true" style="outline: none">Privacy Policy</a>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <a href="Terms of Service_yunbu.html" class hidefocus="true" style="outline: none">Terms of Service</a>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <a href="Legal_Notice_JP.html" class hidefocus="true" style="outline: none">Legal Notice(JP)</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { mdbContainer, mdbRow, mdbCol, mdbView } from 'mdbvue'
export default {
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbView
  },
  data() {
    return {
      name: 'Base',
      news: ['alicemergeland', 'badmintonleague'],
      newsItem: [],
      currentMenu: 'home',
      menu: [
        { name: 'home', title: '首页' },
        {
          name: 'game',
          title: '游戏',
          subs: [
            { name: 'alicemergeland', title: '糖果精灵传奇' },
            { name: 'badmintonleague', title: '羽毛球高高手' },
            { name: 'bubbleelfsaga', title: '泡泡精灵传奇' },
            { name: 'magicgarden', title: '花花姑娘之魔法花园' }
          ]
        },
        { name: 'news', title: '新闻' },
        { name: 'tryplay', title: 'H5游戏' },
        { name: 'about', title: '关于我们' }
      ]
    }
  },
  methods: {
    gotoDetail: function (nameTag) {
      this.$router.push({
        path: 'detail',
        query: { name: nameTag }
      })
    },
    clickMenu: function (name) {
      if (name == 'tryplay') {
        window.open('https://www.yunbu.me/shootball/index.html')
      } else {
        this.currentMenu = name
        this.$router.push({
          path: name
        })
      }
    },
    clickSub: function (parent, sub) {
      this.currentMenu = parent
      this.gotoDetail(sub)
    }
  },
  computed: { ...mapGetters(['getGameByName']) },
  created: function () {
    this.currentMenu = this.$route.path.slice(1)
    this.newsItem = this.getGameByName(this.news)
  }
}
</script>

<style scoped>
.header-main {
  background: #fff;
  min-height: 102px;
  padding-top: 30px;
}
.header-logo {
  width: 50%;
  text-align: left;
}
.site-main {
  position: relative;
  z-index: 1;
}
.header-second {
  min-height: 52px;
  background: #041d22;
  background: -webkit-linear-gradient(top, #041d22 0%, #041d22 100%);
  background: linear-gradient(to bottom, #041d22 0%, #041d22 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff041d22', endColorstr='#ff041d22', GradientType=0);
}
.nav-main {
  float: left;
  position: relative;
  z-index: 1000;
}
.main-navigation ul {
  margin: 0;
  padding: 10px 0 0 0;
  font-family: 'Droid Serif', serif;
  font-size: 16px;
}
.main-navigation ul li {
  position: relative;
  list-style: none;
}
.main-navigation ul > li {
  display: inline-block;
  margin-left: 5px;
}
.main-navigation ul > li > a {
  display: block;
  line-height: 32px;
  color: #fff;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 3px;
}
.main-navigation ul > li.parent.hover > a {
  border-radius: 3px 3px 0 0;
}
.main-navigation ul > li:hover > a,
.main-navigation ul > li.current > a,
.main-navigation ul > li.current-menu-ancestor > a {
  background: #28a0bb;
}
.main-navigation ul > li ul {
  position: absolute;
  top: 32px;
  left: 0;
  z-index: 1308;
  padding: 0;
  width: 180px;
  font-size: 14px;
  display: none;
}
.main-navigation ul > li ul li {
  display: block;
  width: 100%;
  background: #000000;
  background: rgba(0, 0, 0, 0.85);
  border-top: 1px solid #333333;
  margin-left: 0;
}
.main-navigation ul > li ul li a {
  color: #dfdfdf;
  padding: 8px 25px 8px 15px;
  line-height: 1.3em;
  border-radius: 0;
}
.main-navigation ul > li ul li:hover > a,
.main-navigation ul > li ul li.parent.hover > a,
.main-navigation ul > li ul li.current > a,
.main-navigation ul > li ul li.current-menu-ancestor > a {
  border-radius: 0;
  color: #fff;
}
.main-navigation ul > li ul li.parent > a:after {
  display: block;
  float: right;
  font-size: 10px;
  content: '\e624';
  top: 0.5em;
  margin-left: 0px;
  margin-right: -15px;
  color: #fff;
}
.main-navigation ul > li ul li:first-child {
  border-top: 3px solid #28a0bb;
}
.main-navigation ul > li ul li:first-child ul {
  top: -3px;
}
.main-navigation ul > li ul li > ul {
  top: 0px;
  left: 180px;
  padding-left: 2px;
}
.main-navigation ul > li:hover > ul {
  display: block;
}
.main-navigation ul > .mega-nav > ul {
  left: -100%;
  width: 900px;
  border-top: 3px solid #28a0bb;
  background: #000;
  background: rgba(0, 0, 0, 0.85);
  font-family: 'Cabin', sans-serif;
  color: #999999;
}
.main-navigation ul > .mega-nav > ul li {
  float: left;
  border-left: 1px solid #3c3c3b;
  border-right: 1px solid #090a09;
  background: none;
  width: 180px;
}
.main-navigation ul > .mega-nav > ul li:first-child {
  border-top: none;
}
.main-navigation ul > .mega-nav > ul li ul {
  position: relative;
  display: block;
  float: none;
  width: auto;
}
.main-navigation ul > .mega-nav > ul li ul li {
  float: none;
  border: none;
  width: auto;
  border-top: 1px solid #333333;
}
.main-navigation ul > .mega-nav > ul li.mega-nav-widget ul li {
  width: auto;
}
.main-navigation ul > .mega-nav > ul li a,
.main-navigation ul > .mega-nav > ul li.current > a,
.main-navigation ul > .mega-nav > ul li.current-menu-ancestor > a,
.main-navigation ul > .mega-nav > ul li:hover > a {
  background: none;
  padding: 0;
  color: #a4a4a4;
}
.main-navigation ul > .mega-nav > ul li a:hover,
.main-navigation ul > .mega-nav > ul li.current > a:hover,
.main-navigation ul > .mega-nav > ul li.current-menu-ancestor > a:hover,
.main-navigation ul > .mega-nav > ul li:hover > a:hover {
  color: #d7d7d7;
}
.main-navigation ul > .mega-nav > ul > li {
  padding: 20px;
}
.main-navigation ul > .mega-nav > ul > li ul li {
  padding: 10px 0;
}
.main-navigation ul > .mega-nav > ul > li > a {
  font-family: 'Droid Serif', serif;
  color: #fff;
  font-size: 14px;
  text-transform: uppercase;
  margin-bottom: 2em;
  font-weight: bold;
}
.main-navigation ul > .mega-nav > ul > li.parent a:after {
  display: none;
}
.main-navigation ul > .mega-nav > ul li ul,
.main-navigation ul > .mega-nav > ul li.first:hover > ul {
  top: 0;
}
.main-navigation ul > .mega-nav > ul li.first,
.main-navigation ul > .mega-nav > ul li ul li.first {
  border-left: none;
}
.main-navigation ul > .mega-nav > ul li.last,
.main-navigation ul > .mega-nav > ul li ul li.last {
  border-right: none;
}
.main-navigation ul > .mega-nav > ul li:hover > ul,
.main-navigation ul > .mega-nav li > ul {
  position: relative;
  left: 0;
  padding: 0;
}
.main-navigation ul > li ul .mega-nav-widget {
  width: 300px;
  padding: 0;
}
.main-navigation ul .widget {
  padding: 20px;
}
.main-navigation ul .widget-title {
  color: #fff;
  font-size: 14px;
  text-transform: uppercase;
  margin-bottom: 2em;
}
.main-navigation ul .textwidget {
  color: #999999;
  font-family: 'Cabin', sans-serif;
}
.main-navigation ul .widget_recent_entries li {
  padding-bottom: 10px;
  padding-top: 10px;
}
.main-navigation ul .widget_recent_entries li:first-child {
  padding-top: 0;
}
.main-navigation ul .widget_categories li {
  margin-bottom: 0;
}
.main-navigation ul .widget_twitter .tweet_item {
  border-top: 1px solid #333333;
}
.main-navigation ul .widget_twitter .tweet_item:first-child {
  border: none;
}
.main-navigation ul .widget_twitter .tweet_item a {
  color: #eeeeee;
}
/* Only For iPads */
@media (max-width: 960px) {
  /*@media only screen and (device-width: 768px) {*/
  .main-navigation ul > li ul .mega-nav-widget {
    width: 240px;
  }
  .main-navigation ul li ul .mega-nav-widget li,
  .main-navigation ul .mega-nav ul .mega-nav-widget li {
    width: 180px;
  }
  .main-navigation ul .mega-nav .widget_flickr .flickr_badge_image {
    width: 55px;
    height: 55px;
  }
}
.footer-info-container {
  color: #a4a4a4;
  background: #212728;
  position: relative;
  z-index: 1;
}
.copyright {
  padding-left: 20px;
  padding-top: 10px;
  font-size: 13px;
  background: #1c2122;
  padding: 40px;
  text-align: center;
}
.copyright a {
  color: #28a0bb;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.news-content-p {
  color: #4f5e62;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
.third {
  color: #27a0bb;
}
</style>
